import { render, staticRenderFns } from "./DirectorAddEditView.vue?vue&type=template&id=d4b39a68&scoped=true&"
import script from "./DirectorAddEditView.vue?vue&type=script&lang=js&"
export * from "./DirectorAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./DirectorAddEditView.vue?vue&type=style&index=0&id=d4b39a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b39a68",
  null
  
)

export default component.exports